import React, { useCallback, useEffect, useRef, useState } from "react";
import '../Tablero.scss'
import bussIcon from '../../../../assets/icons/buss.png'
import usuarioIcon from '../../../../assets/icons/usuario.png'
import circuloIcon from '../../../../assets/icons/circulo.png'
// import Button from "../../../../components/atoms/Button/Button";
import ModalRegistrarIncidente from "../../../../components/molecules/TablaBitacoras/ModalRegistrarIncidente";
import ModalWhatsAppCliente from "../../../../components/molecules/ModalWhatsAppCliente/ModalWhatsAppCliente";
import "../../../../components/molecules/TablaBitacoras/TablaBitacoras.scss";
import { Button } from "primereact/button";
import { getVelocidadUnidad, getWatsAppConteo, sendWatsAppOp, sendWatsAppCliente } from "./integracionPanel";

const UnidadSeleccionada = ({
    dataUnidad,
    unidadCoordenadas,
    activeIndex,
    setDataUnidadVistaUnidad,
    dataUnidadVistaUnidad,
}) => {
    const [conteoMensajes, setConteoMensajes] = useState(null)
    const [showCrearIncidente, setShowCrearIncidente] = useState()
    const [showModalWhatsAppCliente, setShowModalWhatsAppCliente] = useState(false)
    const [velocidad, setVelocidad] = useState({ VELOCIDAD: 0, timestamp: null })
    const [isLoadingVelocidad, setIsLoadingVelocidad] = useState(false)
    const abortControllerRef = useRef(null)
    const intervalRef = useRef(null)
    const lastItemIdRef = useRef(null)
    const VELOCIDAD_INTERVAL = 10000 // Cambiado de 10000 a 30000ms para reducir carga
  
    const generarIcidente = () => {
        setShowCrearIncidente({ fecha: dataUnidad.FECHA, id_unidad: dataUnidad.ID_BITACORA, bitacora: dataUnidad.ID_BITACORA, ruta: dataUnidad.RUTA, tipo: dataUnidad.TIPO, id_unidad: dataUnidad.UNIDAD })
    }
    useEffect(() => {
        if (dataUnidad) {
            getWatsAppConteo(setConteoMensajes, dataUnidad.ID_BITACORA)
        }
    }, [dataUnidad])

    
    // Función optimizada para obtener velocidad con control de cancelación
    const fetchVelocidad = useCallback(async (itemId) => {
        if (!itemId || isLoadingVelocidad) return

        try {
            // Cancelar petición anterior si existe
            if (abortControllerRef.current) {
                abortControllerRef.current.abort()
            }

            abortControllerRef.current = new AbortController()
            setIsLoadingVelocidad(true)

            await getVelocidadUnidad((newVelocidad) => {
                setVelocidad({
                    VELOCIDAD: newVelocidad?.VELOCIDAD || 0,
                    timestamp: Date.now()
                })
                setIsLoadingVelocidad(false)
            }, itemId)

        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error fetching velocidad:', error)
                setVelocidad(prev => ({ ...prev, VELOCIDAD: 'Error' }))
            }
            setIsLoadingVelocidad(false)
        }
    }, [isLoadingVelocidad])

    // Función para limpiar el intervalo
    const clearVelocidadInterval = useCallback(() => {
        if (intervalRef.current) {

            clearInterval(intervalRef.current)
            intervalRef.current = null
        }
        if (abortControllerRef.current) {
            abortControllerRef.current.abort()
            abortControllerRef.current = null
        }
    }, [])

    // Efecto optimizado para velocidad
    useEffect(() => {
        // Limpiar intervalo anterior
        clearVelocidadInterval()

        // Solo ejecutar si estamos en la vista correcta y hay datos
        if (activeIndex !== 1 || !dataUnidadVistaUnidad?.ITEM_ID_WIALON) {
            setVelocidad({ VELOCIDAD: 0, timestamp: null })
            return
        }

        const itemId = dataUnidadVistaUnidad.ITEM_ID_WIALON

        // Si es el mismo ID que la consulta anterior, no reiniciar
        if (lastItemIdRef.current === itemId && velocidad.timestamp) {
            // Solo configurar el intervalo sin hacer fetch inmediato
            intervalRef.current = setInterval(() => {

                fetchVelocidad(itemId)
            }, VELOCIDAD_INTERVAL)
            return
        }

        // Nuevo ID o primera carga
        lastItemIdRef.current = itemId


        // Fetch inicial
        fetchVelocidad(itemId)

        // Configurar intervalo
        intervalRef.current = setInterval(() => {

            fetchVelocidad(itemId)
        }, VELOCIDAD_INTERVAL)

        // Cleanup function
        return clearVelocidadInterval
    }, [activeIndex, dataUnidadVistaUnidad?.ITEM_ID_WIALON, fetchVelocidad, clearVelocidadInterval])

    // Cleanup al desmontar
    useEffect(() => {
        return () => {
            clearVelocidadInterval()
            setIsLoadingVelocidad(false)
        }
    }, [clearVelocidadInterval])
    const sendWatsAppOpFunct = async () => {
        await sendWatsAppOp(setConteoMensajes, dataUnidad.ID_BITACORA, dataUnidad.TELEFONO)
    }
    const sendWatsAppOpFunctClient = async () => {
        setShowModalWhatsAppCliente(true)
    }

    const handleSendWhatsAppCliente = async (telefono, unidadInfo) => {
        try {
            // Crear el mensaje con toda la información de la unidad
            console.log("unidadInfo", unidadInfo);
            console.log("dataUnidad", dataUnidad);
            let mensaje = `🚌 *Información del servicio*\n\n`;
            if (activeIndex === 0) {
                // Vista de bitácora
                mensaje += `📋 *ID Bitácora:* ${unidadInfo.ID_BITACORA}\n`;
                mensaje += `🚌 *Unidad:* ${unidadInfo.UNIDAD}\n`;
                mensaje += `🔧 *Tipo:* ${unidadInfo.TIPO_UNIDAD}\n`;
                mensaje += `🛣️ *Ruta:* ${unidadInfo.RUTA}\n`;
                mensaje += `👨‍💼 *Operador:* ${unidadInfo.CHOFER}\n`;
                mensaje += `✅ *Confirmada:* ${unidadInfo.CONFIRMADA ? 'Sí' : 'No'}\n`;
                mensaje += `👥 *Capacidad:* ${unidadInfo.CAPACIDAD} pasajeros\n`;
                mensaje += `💺 *Asientos disponibles:* ${unidadInfo.ASIENTOS_DISPONIBLES ? unidadInfo.ASIENTOS_DISPONIBLES : 'Sin datos'}\n`;

                // Agregar ubicación si está disponible
                if (unidadInfo.coordenadas.length > 0) {
                    mensaje += `\n📍 *Ubicación actual:*\n`;
                    mensaje += `Ver en Google Maps:\n`;
                    mensaje += `https://maps.google.com/?q=${unidadInfo.coordenadas[0]},${unidadInfo.coordenadas[1]}\n`;
                }
            } else {
                // Vista de unidades
                mensaje += `🚌 *Unidad:* ${unidadInfo.UNIDAD}\n`;
                mensaje += `📊 *Estatus:* ${unidadInfo.ESTATUS}\n`;
                mensaje += `🔄 *Estado:* ${unidadInfo.ESTADO_UNIDAD}\n`;
                mensaje += `🔧 *Tipo:* ${unidadInfo.TIPO}\n`;
                mensaje += `🛣️ *Ruta:* ${unidadInfo.RUTA || 'Sin ruta asignada'}\n`;
                mensaje += `👨‍💼 *Operador:* ${unidadInfo.OPERADOR || 'Sin operador'}\n`;
                // Agregar horas si están disponibleslog



                if (unidadInfo.HoraInicio) {
                    mensaje += `⏰ *Hora de inicio:* ${unidadInfo.HoraInicio}\n`;
                }
                if (unidadInfo.HoraLlegada) {
                    mensaje += `🏁 *Hora de llegada:* ${unidadInfo.HoraLlegada}\n`;
                }

                // Agregar ubicación si está disponible para vista de unidades
                if (unidadInfo.coordenadas && unidadInfo.coordenadas.length > 0) {
                    mensaje += `\n📍 *Ubicación actual:*\n`;
                    mensaje += `Ver en Google Maps:\n`;
                    mensaje += `https://maps.google.com/?q=${unidadInfo.coordenadas[0]},${unidadInfo.coordenadas[1]}\n`;
                }

               
            }

            
            mensaje += `\n\n🕐 *Enviado:* ${new Date().toLocaleString('es-MX')}`;

            // Llamar a la función de envío (debes implementar esta función en integracionPanel.js)
            await sendWatsAppCliente(telefono, mensaje);


        } catch (error) {
            console.error('Error enviando WhatsApp al cliente:', error);
            throw error;
        }
    }

    return (
        <>
            {
                activeIndex == 0 ?
                    <div className="UnidadSeleccionada">
                        <div className="titulo-panel">
                            {/* <img src={logs} alt="" /> */}
                            <img src={bussIcon} alt="" />
                            <div>
                                <div className="titulo">Propiedades Unidad seleccionada​</div>
                                <div className="subtitulo">Propiedades</div>
                            </div>
                        </div>
                        <div className="propiedades">
                            {
                                dataUnidad ?
                                    <>
                                        <div className="operador">
                                            <img src={usuarioIcon} alt="" />
                                            {
                                                dataUnidad?.CHOFER == 'ALIADO' ?
                                                    <div style={{ color: 'red', fontWeight: 'bold' }}>{dataUnidad?.CHOFER}</div>
                                                    :
                                                    <div>{dataUnidad?.CHOFER}</div>
                                            }

                                        </div>
                                        <div className="descripcion">
                                            <div className={`element ${dataUnidad?.CONFIRMADA ? 'confirmada-si' : 'confirmada-no'}`}>
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Id bitacora:</b>  {dataUnidad?.ID_BITACORA}</div>
                                            </div>
                                            <div className="element">
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Tipo de unidad:</b>  {dataUnidad?.TIPO_UNIDAD}</div>
                                            </div>
                                            <div className="element">
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Ruta:</b>  {dataUnidad?.RUTA}</div>
                                            </div>
                                            <div className="element">
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Teléfono:</b>  {dataUnidad?.TELEFONO || 'No disponible'}</div>
                                            </div>
                                            <div className={`element ${dataUnidad?.CONFIRMADA ? 'confirmada-si' : 'confirmada-no'}`}>
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Confirmada:</b>  {dataUnidad?.CONFIRMADA ? "Sí" : "No"}</div>
                                            </div>
                                            <div className="element">
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Unidad:</b> {dataUnidad?.UNIDAD}</div>
                                            </div>
                                            <div className="element">
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Capacidad:</b> {dataUnidad?.CAPACIDAD} pasajeros</div>
                                            </div>
                                            <div className="element">
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Asientos disponibles:</b> {dataUnidad?.ASIENTOS_DISPONIBLES}</div>
                                            </div>

                                            <div className="buttons-container">


                                                {/* <div className="containerButtonTableroWsClient">
                                                    <Button
                                                    
                                                        severity="primary"
                                                        icon={'pi pi-user'}
                                                        label="Enviar WhatsApp al cliente"
                                                        style={{ width: '100%', backgroundColor: '#007bff', borderColor: '#007bff' }}
                                                        onClick={() => { sendWatsAppOpFunctClient() }}
                                                    />
                                                </div>
                                                <div className="containerButtonTableroWs">
                                                    {conteoMensajes > 0 && (
                                                        <div className="contador">{conteoMensajes}</div>
                                                    )}
                                                    <Button
                                                        disabled={dataUnidad?.TELEFONO ? false : true}
                                                        severity="secondary"
                                                        icon={'pi pi-whatsapp'}
                                                        label="Enviar WhatsApp al operador"
                                                        style={{ width: '100%' }}
                                                        onClick={() => { sendWatsAppOpFunct() }}
                                                    />
                                                </div> */}
                                                <div className="button-wrapper">
                                                    <Button
                                                        disabled={dataUnidad?.CHOFER == 'ALIADO' ? true : false}
                                                        severity="secondary"
                                                        icon={'pi pi-exclamation-triangle'}
                                                        style={{ width: '100%' }}
                                                        label="Generar Incidencia"
                                                        onClick={() => { generarIcidente() }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> :
                                    <div className="no-selection">
                                        <i className="pi pi-map-marker"></i>
                                        <div className="message">Selecciona una unidad</div>
                                        <div className="submessage">Haz clic en una unidad del mapa o de la lista para ver sus propiedades</div>
                                    </div>
                            }
                        </div>
                        {showCrearIncidente ? <ModalRegistrarIncidente data={showCrearIncidente} setShowCrearIncidente={setShowCrearIncidente}></ModalRegistrarIncidente> : ""}
                        {showModalWhatsAppCliente && (
                            <ModalWhatsAppCliente
                                visible={showModalWhatsAppCliente}
                                onHide={() => setShowModalWhatsAppCliente(false)}
                                dataUnidad={dataUnidad}
                                dataUnidadVistaUnidad={dataUnidadVistaUnidad}
                                activeIndex={activeIndex}
                                onSend={handleSendWhatsAppCliente}
                            />
                        )}
                    </div>
                    :
                    <div className="UnidadSeleccionada">
                        <div className="titulo-panel">
                            {/* <img src={logs} alt="" /> */}
                            <img src={bussIcon} alt="" />
                            <div>
                                <div className="titulo">Propiedades Unidad seleccionada​</div>
                                <div className="subtitulo">Propiedades</div>
                            </div>
                        </div>
                        <div className="propiedades">
                            {
                                dataUnidadVistaUnidad ?
                                    <>
                                        <div className="unit-header">
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                <div className="unit-label">Unidad:</div>
                                                <div className="unit-number">{dataUnidadVistaUnidad?.UNIDAD}</div>

                                            </div>
                                        </div>
                                        <div className="descripcion">
                                            <div className={`element ${dataUnidadVistaUnidad?.ESTADO_UNIDAD === 'EN SERVICIO' ? 'status-en-servicio' : 'status-sin-servicio'}`}>
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Estatus:</b>  {dataUnidadVistaUnidad?.ESTATUS}</div>
                                            </div>
                                            <div className={`element ${dataUnidadVistaUnidad?.ESTADO_UNIDAD === 'EN SERVICIO' ? 'status-en-servicio' : 'status-sin-servicio'}`}>
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Estado:</b>  {dataUnidadVistaUnidad?.ESTADO_UNIDAD}</div>
                                            </div>
                                            <div className="element">
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Tipo:</b>  {dataUnidadVistaUnidad?.TIPO}</div>
                                            </div>
                                            <div className="element">
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Ruta:</b>  {dataUnidadVistaUnidad?.RUTA || 'Sin ruta asignada'}</div>
                                            </div>
                                            <div className="element">
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad"> <b>Operador:</b>  {dataUnidadVistaUnidad?.OPERADOR || 'Sin operador'}</div>
                                            </div>
                                            {dataUnidadVistaUnidad?.HoraInicio && (
                                                <div className="element">
                                                    <img src={circuloIcon} alt="" />
                                                    <div className="unidad"> <b>Hora de inicio:</b>  {dataUnidadVistaUnidad?.HoraInicio}</div>
                                                </div>
                                            )}
                                            {dataUnidadVistaUnidad?.HoraLlegada && (
                                                <div className="element">
                                                    <img src={circuloIcon} alt="" />
                                                    <div className="unidad"> <b>Hora de llegada:</b>  {dataUnidadVistaUnidad?.HoraLlegada}</div>
                                                </div>
                                            )}
                                            <div className="element velocity-indicator">
                                                <img src={circuloIcon} alt="" />
                                                <div className="unidad">
                                                    <b>Velocidad:</b>
                                                    {isLoadingVelocidad ? (
                                                        <span className="velocity-value loading"> Actualizando...</span>
                                                    ) : (
                                                        <span className={`velocity-value ${velocidad?.VELOCIDAD === 'Error' ? 'error' : ''}`}>
                                                            {velocidad?.VELOCIDAD || '0'}
                                                            {velocidad?.VELOCIDAD !== 'Error' && velocidad?.VELOCIDAD !== 0 && ' km/h'}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </> :
                                    <div className="no-selection">
                                        <i className="pi pi-map-marker"></i>
                                        <div className="message">Selecciona una unidad</div>
                                        <div className="submessage">Haz clic en una unidad de la lista para ver sus detalles</div>
                                    </div>
                            }
                        </div>
                    </div>
            }
        </>
    )
}
export default UnidadSeleccionada